import { Filter } from '@profgeosoft-ui/icons';
import { Button } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'src/shared/components/search';
import { SwitchButtonGroup } from 'src/shared/components/switch-button-group';

import { PAD_DRILLING_STATUS } from '../../consts';
import { usePadPreparationStore } from '../../use-pad-preparation-store';
import { WellPadPreparationFilter } from '../well-pad-preparation-filter';

import styles from './well-pad-preparation-subheader.module.scss';

export const WellPadPreparationSubheader = observer(function WellPadPreparationSubheader() {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');
  const store = usePadPreparationStore();
  const filterButtonRef = useRef<HTMLButtonElement | null>(null);

  const onSearchChange = (value: string): void => {
    setSearchValue(value);
    store.setSearchValue(value);
  };

  return (
    <div className={styles.wrapper}>
      <SwitchButtonGroup
        onChange={(key) => store.setPadStatusToDisplay(key)}
        value={store.currentPadStatusToDisplay}
        items={[
          {
            key: PAD_DRILLING_STATUS.drilled,
            title: t(`wellPadPreparation:Sections.${PAD_DRILLING_STATUS.drilled}`),
          },
          {
            key: PAD_DRILLING_STATUS.planned,
            title: t(`wellPadPreparation:Sections.${PAD_DRILLING_STATUS.planned}`),
          },
          {
            key: PAD_DRILLING_STATUS.unplanned,
            title: t(`wellPadPreparation:Sections.${PAD_DRILLING_STATUS.unplanned}`),
          },
          {
            key: PAD_DRILLING_STATUS.updated,
            title: t(`wellPadPreparation:Sections.${PAD_DRILLING_STATUS.updated}`),
          },
        ]}
      />

      <div className={styles.rightControlBlock}>
        <Search
          value={searchValue}
          placeholder={t('common:search')}
          suffix={
            <Button
              ref={filterButtonRef}
              variant={store.filterStore.isFilterActive ? 'primary' : 'flat'}
              icon={<Filter />}
              className={styles.filterButton}
              onClick={store.toggleFilterModal}
            />
          }
          onSearch={onSearchChange}
        />
      </div>
      <WellPadPreparationFilter
        isOpen={store.isFilterModalOpened}
        filterStore={store.filterStore}
        onClose={() => store.setIsFilterModalOpen(false)}
      />
    </div>
  );
});
